import { Dialog } from 'quasar';
import { i18n } from '@/plugins/i18n';

const t = i18n.global.t;

/** The yes/no confirmation before a delete; `typeName` is what is deleted, already translated. */
export const confirmDelete = (typeName: string) =>
  Dialog.create({
    title: t('global.dialogs.deleteTitle', { type: typeName }),
    message: t('global.dialogs.deleteMessage', { type: typeName }),
    ok: { label: t('global.yes'), color: 'negative', flat: true },
    cancel: { label: t('global.no'), color: 'primary', unelevated: true },
  });
